'use client';
import * as React from 'react';
import classNames from 'classnames';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { separatorPropDefs } from './separator.props';
import { extractMarginProps, withMarginProps, withBreakpoints } from '../helpers';
const Separator = React.forwardRef((props, forwardedRef) => {
    const { rest: marginRest, ...marginProps } = extractMarginProps(props);
    const { className, size = separatorPropDefs.size.default, color = separatorPropDefs.color.default, ...separatorProps } = marginRest;
    return (React.createElement(SeparatorPrimitive.Root, { "data-accent-color": color, ...separatorProps, ref: forwardedRef, className: classNames('rt-Separator', className, withBreakpoints(size, 'rt-r-size'), withMarginProps(marginProps)) }));
});
Separator.displayName = 'Separator';
export { Separator };
//# sourceMappingURL=separator.js.map